export default __webpack_public_path__ + "887fcc11c2f982b1492633eeb95e33f9.png";